import { render, staticRenderFns } from "./landing-protection.vue?vue&type=template&id=128528f2&scoped=true&"
import script from "./landing-protection.vue?vue&type=script&lang=ts&"
export * from "./landing-protection.vue?vue&type=script&lang=ts&"
import style0 from "./landing-protection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./landing-protection.vue?vue&type=style&index=1&id=128528f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128528f2",
  null
  
)

export default component.exports